import React, { createContext, useState, ReactNode, useContext } from 'react';

interface MenuContextType {
  menuList: string[];
  updateMenu: (items: string[]) => void;
}

const MenuContext = createContext<MenuContextType | undefined>(undefined);

interface MenuContextProviderProps {
  children: ReactNode;
}

export const MenuContextProvider: React.FC<MenuContextProviderProps> = ({ children }) => {
  const [menuList, setMenu] = useState<string[]>([]);

  const updateMenu = (items: string[]) => {
    setMenu(items);
  };

  return <MenuContext.Provider value={{ menuList, updateMenu }}>{children}</MenuContext.Provider>;
};

export const useMenuContext = () => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('useMenuContext must be used within a MenuContextProvider');
  }
  return context;
};
